module.exports = __webpack_public_path__ + "img/default-avatar.adc0d7c1.png";